import { action } from 'easy-peasy';
import { IActionRemoveAvatar } from '../types';

const removeAvatar: IActionRemoveAvatar = action(state => {
  state.current.photo = '';
});

export default removeAvatar;
